<!-- 全人发展卡 - 生命之轮 -->
<template>
  <div class="game-1">
    <nf-card borderInnerSize="0" round=".2rem">
      <div class="game-1-box">
        <div class="game-1-box-list">
          <div class="game-1-box-list-wheel">{{ gameInfo.cateName }}</div>
          <Swipe ref="swipeRef" :show-indicators="false" :loop="false">
            <swipe-item style="height: auto">
              <div class="game-1-box-list-wheel-box-right">
                <div class="game-1-box-list-wheel-box-right-item">
                  <div
                    class="game-1-box-list-wheel-box-right-item-step"
                    style="width: 1.6rem"
                  ></div>

                  <div
                    style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                      width: 100%;
                      font-weight: bold;
                    "
                  >
                    <div>1分</div>
                    <div>10分</div>
                  </div>
                </div>

                <div
                  v-for="(item, index) in gameList"
                  class="game-1-box-list-wheel-box-right-item"
                  :key="index"
                >
                  <div class="game-1-box-list-wheel-box-right-item-check">
                    {{ item.name }}
                  </div>
                  <Slider
                    :button-size="12"
                    class="game-1-box-list-wheel-box-right-item-step"
                    v-model="item.value"
                    :step="1"
                    :max="10"
                    :min="0"
                    buttonSize="20"
                    :active-color="item.color"
                  />
                  <div class="game-1-box-list-wheel-box-right-item-value">
                    {{ item.value }}
                  </div>
                </div>

                <NfButton
                  color="rgb(172,185,233)"
                  round=".5rem"
                  style="margin-top: 0.2rem"
                  class="card-select-btns-btn"
                  @click.native="changeSwiper(1)"
                  >查看轮盘</NfButton
                >
              </div>
            </swipe-item>
            <SwipeItem style="height: auto">
              <div
                style="
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: center;
                  height: 100%;
                "
              >
                <div
                  class="game-1-box-list-wheel-box-left"
                  style="
                    pointer-events: none;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    height: 100%;
                  "
                >
                  <MorebarEchart
                    width="380px"
                    height="380px"
                    @click.stop
                    :distData="gameList"
                  />
                </div>
                <NfButton
                  color="rgb(172,185,233)"
                  round=".5rem"
                  @click.native="changeSwiper(0)"
                  >查看打分</NfButton
                >
              </div>
            </SwipeItem>
          </Swipe>
          <div class="game-1-box-list-divider"></div>
          <!-- 确认选择 -->
          <NfButton
            :disabled="!isConfirm"
            color="rgb(172,185,233)"
            round=".5rem"
            style="margin-top: 0.2rem; padding: 0 0.2rem"
            class="card-select-btns-btn"
            @click.native="confirmHandle"
            >确认选择</NfButton
          >
        </div>
      </div>
    </nf-card>
  </div>
</template>

<script>
import NfCard from "@/components/game-ui/NfCard.vue";
import CardReverseAndConfirm from "@/components/game-comm/CardReverseAndConfirm.vue";
import {
  Swipe,
  SwipeItem,
  Image as VanImage,
  Grid,
  GridItem,
  Checkbox,
  Slider,
} from "vant";
import NfButton from "@/components/game-ui/NfButton.vue";
import { MorebarEchart } from "@/components/echarts";
import cookie from "@utils/store/cookie";

export default {
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          name: "",
          roleTab: 0,
        };
      },
    },
    cardList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    gameInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
    form: {},
    sizeType: {
      type: String,
      default: "big",
    },
    gameStatus: {
      type: Number,
      default: 1,
    },
    frontSelectCardList: {
      type: Array,
      default: () => {
        return [];
      },
    },

    game3Lock: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    console.log("game3 mounted");
    this.changeGameResult();
  },

  activated() {
    console.log("game3 activated");
  },
  data() {
    return {
      selectActiveCardList: [],
      selectCardList: [],
      firstLock: [],
      gameList: [],
      game3List: [
        {
          name: "同伴",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "异性",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 195, 125)",
          borderColor: "rgba(255, 195, 125, 2)",
        },
        {
          name: "老师",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(92, 211, 231)",
          borderColor: "rgba(92, 211, 231)",
        },
        {
          name: "学习",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 215, 39)",
          borderColor: "rgba(255, 215, 39)",
        },
        {
          name: "自我",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(97, 216, 81)",
          borderColor: "rgba(97, 216, 81)",
        },
        {
          name: "兴趣",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(193, 169, 253)",
          borderColor: "rgba(193, 169, 253)",
        },
        {
          name: "娱乐",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(230, 118, 247)",
          borderColor: "rgba(230, 118, 247)",
        },
        {
          name: "家庭",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(110, 144, 255)",
          borderColor: "rgba(110, 144, 255)",
        },
        {
          name: "偶像",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(93, 193, 156)",
          borderColor: "rgba(93, 193, 156)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(255, 129, 129)",
          borderColor: "rgba(255, 129, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 109, 129)",
          borderColor: "rgba(155, 109, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(55, 129, 119)",
          borderColor: "rgba(55, 129, 119)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(155, 29, 129)",
          borderColor: "rgba(155, 29, 129)",
        },
        {
          name: "其他",
          max: 10,
          value: 0,
          checked: false,
          color: "rgb(5, 129, 19)",
          borderColor: "rgba(5, 129, 129)",
        },
      ],
    };
  },
  components: {
    NfCard,
    NfButton,
    Swipe,
    SwipeItem,
    VanImage,
    Grid,
    GridItem,
    MorebarEchart,
    Checkbox,
    Slider,
    CardReverseAndConfirm,
  },
  computed: {
    isConfirm() {
      // 所有选项的分数都不为0
      return this.gameList.every((item) => {
        return item.value != 0;
      });
    },
  },
  watch: {
    // 监听卡牌列表的变化，同步到gameList中
    cardList: {
      handler(list) {
        if (list.length > 0) {
          // 裁剪gameList的长度
          this.gameList.splice(list.length, this.gameList.length - list.length);
          // 让gameList中的value
          this.changeGameResult();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    // 确认选择
    confirmHandle() {
      this.$dialog.message("您可提示用户点击此按钮进行提交操作");
    },
    // 放回卡牌
    putCardHandle(index) {
      this.gameList[index].value = 0;
    },
    checkHandle(item) {
      if (!item.checked) {
        item.value = 5;
      } else {
        item.value = 0;
      }
    },
    changeSwiper(index) {
      this.$refs.swipeRef.swipeTo(index);
    },
    changeGameResult() {
      this.cardList.map((item, index) => {
        const data = {
          ...this.game3List[index],
          value: 0,

          name: item.cardName || "",
          color: item.colour || this.game3List[index].color,
        };
        this.gameList.push(data);
      });
      console.log(this.gameList, "55555555555", this.cardList);
    },
  },
};
</script>

<style lang="scss" scoped>
.game-1 {
  color: #666;
  &-box {
    &-title {
      text-align: center;
    }

    &-list {
      ::v-deep .van-grid-item__content {
        padding: 0.1rem;
      }

      &-divider {
        // 虚线
        border-top: 1px dashed #666;
        margin: 0.3rem 0;
      }

      &-select {
        &-btns {
          display: flex;
          justify-content: space-between;
          margin-top: 0.2rem;
          &-btn {
            margin: 0 0.2rem;
          }
        }
      }

      &-wheel {
        &-box {
          display: flex;

          &-left {
            padding: 0 0.2rem;
            display: flex;
            align-items: center;
          }

          &-right {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            padding: 0 0.2rem;

            font-size: 0.2rem;
            width: 100%;
            &-item {
              display: flex;
              align-items: center;
              height: 0.6rem;
              &-check {
                flex-shrink: 0;
                margin-right: 0.4rem;
                font-size: 0.23rem;
              }
              &-value {
                font-size: 0.25rem;
                // padding: 0 0.05rem;
                padding-left: 0.3rem;
              }
            }
          }
        }
      }
    }

    &-step {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 0.2rem;

      &-left {
      }
      &-right {
        flex: 1;
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        &-item {
          display: flex;
          // align-items: center;
          justify-content: space-between;
          margin: 0.1rem 0;
          &-text {
            font-size: 0.25rem;
          }
          &-icon {
          }
        }
      }
    }
  }
}
</style>
